import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DateUtils, UrlUtils } from '@atlassian/mpac-utils';
import { lastDayOfMonth, lastDayOfYear, startOfMonth, startOfYear } from 'date-fns';
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import queryString from 'query-string';
import { partnerReportsRoute } from '../../../constants/Routes';
import { defaultFilters } from './defaultFilters';
import { reportsWithTabFilterComponent } from './filtersOptions';
import { allFilters } from './filtersToBeShownByReport';
/*
  This function check whether selected date is valid Date or not
*/
const takeIfValidDate = dateStr => dateStr && !Number.isNaN(Date.parse(dateStr)) ? dateStr : null;

/*
  This function helps to take the respective array item, in case the param
  is passed as an array. It'll happen when the user directly pass params in the URL
*/
const getValueFromQueryParam = value => {
  if (Array.isArray(value) && value.length > 0) {
    return null;
  } else {
    var _value$toString;
    return (_value$toString = value === null || value === void 0 ? void 0 : value.toString()) !== null && _value$toString !== void 0 ? _value$toString : null;
  }
};
export const getNewReportPathname = function getNewReportPathname(partnerId, currentReportName) {
  let shouldAppendUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let selectedOptionValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return UrlUtils.resolveUrlFromTemplateAndParameters({
    template: UrlUtils.transformRoutePathToUriTemplate({
      routePath: partnerReportsRoute.path
    }),
    parameters: {
      partnerId,
      reportName: shouldAppendUrl ? selectedOptionValue : currentReportName
    }
  });
};
export const getDateRangeForAPeriodFilter = period => {
  const today = new Date();
  const lastMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const lastYearDate = new Date(today.getFullYear() - 1, 1, 1);
  let startDate = DateUtils.ISOFormatHyphenatedDate(new Date());
  let endDate = DateUtils.ISOFormatHyphenatedDate(new Date());
  switch (period) {
    case 'past30Days':
      startDate = DateUtils.ISOFormatHyphenatedDate(DateUtils.subtractDateByDays(new Date(), 30));
      break;
    case 'past90Days':
      startDate = DateUtils.ISOFormatHyphenatedDate(DateUtils.subtractDateByDays(new Date(), 90));
      break;
    case 'thisMonth':
      startDate = DateUtils.ISOFormatHyphenatedDate(startOfMonth(new Date()));
      break;
    case 'lastMonth':
      startDate = DateUtils.ISOFormatHyphenatedDate(startOfMonth(lastMonthDate));
      endDate = DateUtils.ISOFormatHyphenatedDate(lastDayOfMonth(lastMonthDate));
      break;
    case 'thisYear':
      startDate = DateUtils.ISOFormatHyphenatedDate(startOfYear(new Date()));
      break;
    case 'lastYear':
      startDate = DateUtils.ISOFormatHyphenatedDate(startOfYear(lastYearDate));
      endDate = DateUtils.ISOFormatHyphenatedDate(lastDayOfYear(lastYearDate));
      break;
  }
  return {
    startDate,
    endDate
  };
};
export const getDefaultFiltersByReport = (reportName, currentParams) => {
  const filters = defaultFilters[reportName];
  if (!filters) {
    return filters;
  }
  if (!reportsWithTabFilterComponent.includes(reportName)) {
    return "?".concat(queryString.stringify(filters));
  }
  allFilters[reportName].forEach(filter => {
    if (filter.component === 'Tabs') {
      filters[filter.queryParam] = currentParams[filter.queryParam];
    }
  });
  return "?".concat(queryString.stringify(filters));
};

// The values of following filters will be persisted across filters
const filtersToBePersisted = ['period', 'startDate', 'endDate', 'addon', 'hosting', 'text'];
export const excludedTrendsFilters = ['Date range', 'startDate', 'endDate'];
export const excludedExploreFilters = ['Date range', 'startDate', 'endDate'];
export const reportNameMapping = {
  sales: 'Sales',
  evaluations: 'Evaluations',
  feedback: 'Feedback',
  conversions: 'Cloud Conversions (%)',
  renewals: 'Cloud renewals (%)',
  churn: 'Cloud churn (%)'
};
export const defaultMetricMapping = {
  sales: 'Hosting',
  evaluations: 'Hosting',
  feedback: 'Feedback reason',
  conversions: '',
  renewals: '',
  churn: 'Rate'
};

/*
  This function handles cases when startDate or endDate is changed. It covers cases when
  startDate > endDate or there is no change in dates as per period date range
*/
export const getValidDateRangeAndPeriod = (startDate, endDate, period, selectedOptionValue, selectedOptionQueryParam) => {
  const dateRangeOfSelectedPeriod = getDateRangeForAPeriodFilter(period);
  let updatedStartDate = takeIfValidDate(getValueFromQueryParam(startDate));
  let updatedEndDate = takeIfValidDate(getValueFromQueryParam(endDate));
  // when selected period is not custom, one of startDate or endDate will achieve its period range value
  if (period !== 'custom') {
    if (selectedOptionQueryParam === 'startDate') {
      updatedEndDate = dateRangeOfSelectedPeriod.endDate;
    } else {
      updatedStartDate = dateRangeOfSelectedPeriod.startDate;
    }
  }
  let newParams = {
    period
  };
  const isStartDateGreaterThanEndDate = new Date(updatedStartDate) > new Date(updatedEndDate);
  const isSelectedRangeMatchesItsPeriodRange = updatedStartDate === dateRangeOfSelectedPeriod.startDate && updatedEndDate === dateRangeOfSelectedPeriod.endDate;
  if (isStartDateGreaterThanEndDate) {
    newParams = {
      startDate: selectedOptionValue,
      endDate: selectedOptionValue,
      period: 'custom'
    };
  } else if (!isSelectedRangeMatchesItsPeriodRange) {
    newParams = {
      startDate: updatedStartDate,
      endDate: updatedEndDate,
      period: 'custom'
    };
  }
  return newParams;
};
export const getNewSearch = (currentParams, selectedOptionQueryParam, selectedOptionValue, isFilterGroup) => {
  if (!selectedOptionQueryParam) {
    let defaultFiltersForReport = [];

    // default(core) report filters are always of single value type
    if (!Array.isArray(selectedOptionValue)) {
      defaultFiltersForReport = _objectSpread({}, defaultFilters[selectedOptionValue]);
    }
    filtersToBePersisted.forEach(filter => {
      if (currentParams[filter]) {
        defaultFiltersForReport[filter] = currentParams[filter];
      }
    });
    return "?".concat(queryString.stringify(defaultFiltersForReport));
  }
  let newParams = {};

  // Reset offset for every change in the filters
  if (currentParams.offset) {
    newParams.offset = null;
  }

  // The selected option is an array of values in case of multi select input
  if (Array.isArray(selectedOptionValue)) {
    selectedOptionValue = selectedOptionValue.map(value => value === null || value === void 0 ? void 0 : value.toString().trim());
  } else {
    var _selectedOptionValue;
    selectedOptionValue = (_selectedOptionValue = selectedOptionValue) === null || _selectedOptionValue === void 0 ? void 0 : _selectedOptionValue.toString().trim();
  }
  newParams[selectedOptionQueryParam] = selectedOptionValue;
  if (selectedOptionQueryParam === 'period') {
    newParams.startDate = null;
    newParams.endDate = null;
    if (selectedOptionValue === 'custom') {
      newParams.startDate = DateUtils.ISOFormatHyphenatedDate(DateUtils.subtractDateByDays(new Date(), 90));
      newParams.endDate = DateUtils.ISOFormatHyphenatedDate(new Date());
    }
  }
  // newParams[selectedOptionQueryParam] null case is handled i.e when period is allDates
  else if ((selectedOptionQueryParam === 'endDate' || selectedOptionQueryParam === 'startDate') && newParams[selectedOptionQueryParam]) {
    const startDate = newParams.startDate || currentParams.startDate;
    const endDate = newParams.endDate || currentParams.endDate;
    newParams = getValidDateRangeAndPeriod(startDate, endDate, currentParams.period, selectedOptionValue, selectedOptionQueryParam);
  }

  /**
   * This is done because the filters in the filterGroup object first merges all the query Params
   * Obtained from different calls and then stringifies the Final Object at the call Site as opposed
   * to Single Calls.
   */
  return isFilterGroup ? pickBy(_objectSpread(_objectSpread({}, currentParams), newParams), identity) : "?".concat(queryString.stringify(pickBy(_objectSpread(_objectSpread({}, currentParams), newParams), identity)));
};
export const getQueryParamsValue = (options, queryParamKey, queryParams, reportName, isMultiSelect, controlType) => {
  // Differentiate b/w Report Filter and Other Filters (Report .
  const value = queryParamKey ? queryParams[queryParamKey] : reportName;

  // Must return an Option[] for multi select
  if (isMultiSelect) {
    if (queryParams[queryParamKey]) {
      if (Array.isArray(value)) {
        return options ? options.filter(option => value.includes(option.value)) : queryParams[queryParamKey];
      }
    } else {
      // the empty state for multi select is empty [] and not undefined, unlike in single select
      return [];
    }
  }
  if (controlType === 'checkbox') {
    if (queryParams[queryParamKey]) {
      if (Array.isArray(value)) {
        return queryParams[queryParamKey];
      } else {
        return [value];
      }
    }
    return;
  }

  // In case filter has no data
  if (!options) {
    if (queryParamKey === 'startDate' || queryParamKey === 'endDate') {
      // when period is not custom, selected period will be prioritized to set date ranges
      return queryParams.period !== 'custom' ? getDateRangeForAPeriodFilter(queryParams.period)[queryParamKey] : takeIfValidDate(getValueFromQueryParam(queryParams[queryParamKey]));
    }
    return queryParams[queryParamKey];
  }

  // In case of Select, will return an option
  return options.find(option => option.value === value);
};
export const getSelectedFilterValue = event => {
  // in case of an HTMLEvent
  if (event.target) {
    var _event$target;
    return (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
  }

  // in case of an Select Option
  if (event.label) {
    return event.value || '';
  }

  // in case of a multi select option
  if (Array.isArray(event)) {
    return event.map(option => option.value);
  }
  return event;
};